import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';

import { from, Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	token: string;

	constructor(private afAuth: AngularFireAuth) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
		return this.afAuth.authState.pipe(
			take(1),
			switchMap(u => {
				let t: any = of(null);
				if (u) {
					t = from(u.getIdToken(false));
				}
				return t.pipe(
					switchMap(token => {
						const req = request.clone({
							setHeaders: {
								Authorization: `${token}`
							}
						});
						return next.handle(req);
					})
				);
			})
		);
	}
}
